import { AlertProvider } from "./context/AlertContext";
import { ToastContainer } from "react-toastify";
import RoutesWrapper from "./routes";
import { ErrorAlert, SuccessAlert } from "./components";
import ConfirmAlert from "./components/Alert/ConfirmAlert";
import { TourProvider } from "@reactour/tour";
import { useContext } from "react";
import { AuthContext } from "./context";
import { adminSteps, userSteps } from "./helpers/tourSteps";

function App() {
  const { user } = useContext(AuthContext);
  return (
    <AlertProvider>
      <TourProvider steps={user?.role === "Admin" ? adminSteps : userSteps}>
        <ToastContainer />
        <RoutesWrapper />
        <ErrorAlert autoClose={false} />
        <SuccessAlert autoClose={false} />
        <ConfirmAlert autoClose={false} />
      </TourProvider>
    </AlertProvider>
  );
}

export default App;
